import { ax } from "src/common/api/apiClient";

export const fetchWrapper = {
  get,
  post,
  put,
  delete: _delete,
};

function get(API_ENDPOINT: any) {
  return ax.get(API_ENDPOINT).then(handleResponse);
}

function post(API_ENDPOINT: any, body: any) {
  const requestOptions = {
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  };
  return ax.post(API_ENDPOINT, requestOptions).then(handleResponse);
}

function put(API_ENDPOINT: any, body: any) {
  const requestOptions = {
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  };
  return ax.put(API_ENDPOINT, requestOptions).then(handleResponse);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(API_ENDPOINT: any) {
  return ax.delete(API_ENDPOINT).then(handleResponse);
}

// helper functions

function handleResponse(response: any) {
  return response.data;
}
